import type { DepartamentosPageModel } from '@/interfaces/model';
import type { DepartamentosPage } from '@/interfaces/strapi';

export const departamentosMapper = (item: DepartamentosPageModel): DepartamentosPage => ({
	departaments: (item.departamentos ?? []).map((d) => ({
		id: d.id,
		name: d.name,
		address: d.direccion,
		phone: d.telefono,
		map: d.mapa,
	})),
});
